module.exports = __webpack_public_path__ + "img/slide10.76937597.png";